import { useState } from 'react';
import './ModalTerms.css';

const ModalTerms = ({ onAccept }) => {
  const [aceptado, setAceptado] = useState(false);

  return (
    <div className="modalTermsBackground">
      <div className="modalTermsContainer">
        <h3>Términos y Condiciones</h3>
        <div className="modalTermsText">
          <p>
            Para continuar utilizando el Portal de Proveedores, es necesario
            que leas y aceptes los términos y condiciones de uso.
          </p>
        </div>
        <label className="modalTermsCheckLabel">
          <input
            type="checkbox"
            checked={aceptado}
            onChange={(e) => setAceptado(e.target.checked)}
          />
          Acepto
        </label>
        <button
          className="modalTermsAcceptBtn"
          disabled={!aceptado}
          onClick={onAccept}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default ModalTerms;
